import { Spin, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
    getFundAccountMapping,
    FundAccountFilter,
    FundAccountPagedList,
    FundAccountPayload,
} from 'api/master';
import { LoadingScreen } from 'common/components';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';

// 👈 1. FIXED: Initialized clean fallback object to prevent 'undefined' component unmounting loops
const initialPagedList: FundAccountPagedList = {
    data: [],
    noOfRecords: 0,
    currentPageIndex: 1,
};

//let fundAccountPagedList: FundAccountPagedList;
//let retryResponse: RetryResponse;

type Props = {
    filter: FundAccountFilter;
    onSubmit: (values: FundAccountFilter) => Promise<void>;
};

//const filterPayload: FundAccountPayload = {};

const FundAccountList = ({ filter }: Props) => {
    //const navigate = useNavigate();
    //const [form] = Form.useForm<SourcePayload>();
    // const [pagedList, setPagedList] = useState(fundAccountPagedList);
    const [pagedList, setPagedList] = useState<FundAccountPagedList>(initialPagedList);
    //const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);
    //  const [isModalLoading] = useState(false);
    // const [_isfilter, setFilter] = useState(filterPayload);
    //const [auditLog, setAuditLog] = useState(audit);
    const [_isRetry] = useState(false);
    const [isActive, setIsActive] = useState(true);
    //const [_retryRes, setRetryRes] = useState(retryResponse);
    //const isAdmin = sessionStorage.getItem('isAdmin');

    // 👈 2. FIXED: Ref lock tokens to prevent duplicate backend requests
    const isFetchingRef = useRef(false);
    const lastFilterRef = useRef('');

    useEffect(() => {
        // Construct isolated clone request payload without mutating props directly
        const requestPayload: FundAccountFilter = {
            ...filter,
            pageNo: 1,
            pageSize: 10,
            isExtract: false,
            isActive: filter.isActive === false ? false : isActive,
        };

        const filterStr = JSON.stringify(requestPayload);

        // Lock check: stop duplicate calls if identical payload or request in-flight
        if (lastFilterRef.current === filterStr || isFetchingRef.current) {
            return;
        }

        lastFilterRef.current = filterStr;
        isFetchingRef.current = true;
        setIsTableLoading(true);

        // setIsLoading(false);
        // setPagedList(fundAccountPagedList);
        // setFilter(filterPayload);
        debugger;
        // filter.pageNo = 1;
        // filter.pageSize = 10;
        // filter.isExtract = false;
        //        if (filter.isActive == false) { filter.isActive = false } else { filter.isActive = isActive; }
        getFundAccountMapping(requestPayload)
            .then((res) => {
                setPagedList(res.data);
            })
            .finally(() => {
                setIsLoading(true);
                setIsTableLoading(false);
                isFetchingRef.current = false;
            });
        console.log(setIsActive);
    }, [JSON.stringify(filter)]);
    // const handleDelete = useCallback(
    //     async (values: FundAccountPayload) => {
    //         setIsLoading(true);
    //         setDeleted(true);
    //         deleteFundAccountMapping(values)
    //             .then((res) => {
    //                 if (res != null) {
    //                     message.success('Source Deleted!');
    //                     form.resetFields();
    //                 } else {
    //                     message.error('Some Error Occured');
    //                 }
    //             })
    //             .finally(() => {
    //                 setDeleted(false);
    //                 form.resetFields([]);
    //                 navigate('/master/fundaccount');
    //             });

    //     },
    //     [filter, form]
    // );

    const columns: ColumnsType<FundAccountPayload> = [
        {
            key: 'LoanType',
            title: 'Loan Type',
            dataIndex: 'LoanType',
            fixed: 'left',
            ellipsis: true,
            render: (_, record) => (
                <>
                    <Link to="/master/fundaccount/updatefundaccount" state={record}>
                        {_}
                    </Link>
                </>
            ),
        },
        {
            key: 'SourceApplicationName',
            title: 'Source Application Name',
            dataIndex: 'SourceApplicationName',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'PaymentPurpose',
            title: 'Payment Purpose',
            dataIndex: 'PaymentPurpose',
            fixed: 'left',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'ChargesBearBy',
            title: 'Charges Bear By',
            dataIndex: 'ChargesBearBy',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'MerchantID',
            title: 'Merchant',
            dataIndex: 'MerchantID',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'FundingAccount',
            title: 'Funding Account',
            dataIndex: 'FundingAccount',
            width: 250,
        },
        {
            key: 'ReceiptService',
            title: 'Receipt Service',
            dataIndex: 'ReceiptService',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'RazorPayKey',
            title: 'RazorPay Key',
            dataIndex: 'RazorPayKey',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        {
            key: 'RazorSecret',
            title: 'RazorPay Secret',
            dataIndex: 'RazorSecret',
            ellipsis: true,
            render: (record) => (
                <Tooltip placement="topLeft" title={record}>
                    {record}
                </Tooltip>
            ),
        },
        // {
        //     key: 'Action',
        //     title: 'Action',
        //     dataIndex: 'action',
        //     ellipsis: true,
        //     render: (_, _record) => (
        //         <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(_record)}>
        //             <a>
        //                 <DeleteFilled style={{ fontSize: '16px', marginLeft: '50px' }} />
        //             </a>
        //         </Popconfirm>
        //     ),
        // },
    ];

    if (!pagedList || !isLoading) {
        return <LoadingScreen />;
    }

    const handleChange = (_pagination: any, _filters: FundAccountFilter, sorter: any) => {
        setIsLoading(true);

        if (sorter.hasOwnProperty('column')) {
            // params.order = { field: sorter.field, dir: sorter.order };
        }

        const requestPayload: FundAccountFilter = {
            ...filter,
            pageNo: _pagination.current,
            pageSize: _pagination.pageSize,
            isExtract: false,
            isActive: filter.isActive === false ? false : isActive,
        };

        // filter.pageNo = _pagination.current;
        // filter.pageSize = _pagination.pageSize;

        getFundAccountMapping(requestPayload).then((res) => {
            setPagedList(res.data);
            setIsLoading(true);
        }).finally(() => {
            setIsTableLoading(false);
        });
    };

    const maxWidthPerCell = 1000;

    const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
    const tableHeight = 500;
    const rowKey = 'ROWNUM';



    return (
        <>
            <Spin spinning={isTableLoading}>
                <Table
                    columns={dataTable.columns}
                    dataSource={dataTable.source}
                    rowKey={rowKey}
                    scroll={{ x: dataTable.tableWidth, y: tableHeight }}
                    pagination={{
                        pageSize: 10,
                        total: pagedList.noOfRecords,
                        current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
                    }}
                    onChange={handleChange}
                />
            </Spin>
            ;
        </>
    );
};

export default FundAccountList;
